var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2135_45677)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#EDF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.91 1081.32L1052.87 1043.83C1053.83 1025.24 1051.27 1006.64 1045.3 988.838L1043.49 983.456L1029.69 947.545L1013.56 909.44C1009.17 899.121 1005.66 888.51 1003.05 877.701C1000.72 868.069 999.239 858.281 998.632 848.432L994.986 790.361L990.844 654.921C990.564 645.979 989.701 637.06 988.262 628.211L984.741 607.35C983.152 597.506 980.846 587.771 977.836 578.208L967.549 545.725L957.884 519.153C954.853 510.853 951.294 502.722 947.224 494.801L904.874 412.478L750.162 126.139L715.498 71C711.998 65.5 704.298 53.1 701.498 47.5C698.698 41.9 692.664 29.8333 689.998 24.5C686.831 16.6667 678.698 0 671.498 -4",
    stroke: "#00A8E2",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.65 600.821L984.7 578.548L982.422 553.565L982.311 552.846C978.978 530.204 971.902 508.155 961.322 487.452L912.856 400.478L866.432 307.983C864.109 303.387 862.125 298.653 860.495 293.815L855.828 279.886C854.296 275.311 853.519 270.553 853.522 265.769C853.519 262.955 853.787 260.146 854.322 257.374L856.035 248.74C856.665 245.515 857.65 242.356 858.976 239.311L859.749 237.521C862.404 231.383 866.408 225.806 871.514 221.135L872.37 220.353C875.246 218.569 883.198 213.7 891.998 208.5C902.998 202 924.998 207 934.498 197.5C939.998 194 953.498 187.199 959.498 187.999C965.498 188.799 974.998 186 978.498 188",
    stroke: "#00A8E2",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.87 1081.35L1031.14 1078.55C1033.23 1057.28 1031.75 1035.85 1026.76 1014.99L1024.58 1005.87L1016.04 976.725L1002.35 937.649L994.163 910.385C993.155 907.057 992.285 903.692 991.526 900.301L986.955 879.881L977.828 661.274L976.834 647.093C975.968 635.035 974.454 623.043 972.291 611.119L971.697 607.892C968.955 592.839 965.169 577.961 960.36 563.346L959.09 559.489C954.124 544.44 948.086 529.702 941.015 515.372C936.615 506.456 931.823 497.725 926.641 489.179L887.77 424.969L776.586 220.354L739 160.5C731.834 150.667 717.2 130 716 126C714.8 122 701.5 106.333 695 99C681.667 79.6667 654.9 40.2 654.5 37C654.1 33.8 638.667 5 631 -9",
    stroke: "#D1CDF0",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.881 412.139L952.202 486.054L956.828 493.289C961.7 500.921 967.626 507.949 974.461 514.201L978.797 518.159C982.717 521.706 985.981 525.81 988.463 530.31V530.31C992.003 536.819 993.828 543.993 993.793 551.259V561.041L999.496 654.204L1008.04 841.589L1010.22 862.563C1011.05 870.417 1012.76 878.172 1015.32 885.706L1019.46 897.794L1043.85 960.415C1045.84 965.498 1047.36 970.727 1048.38 976.046L1050.57 987.529C1052.19 996.036 1052.99 1004.66 1052.95 1013.29L1052.81 1043.54",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.938 559.173L1304.57 548.849L1652.44 538.437L1706.61 536.358H1733.17C1736.54 536.357 1739.83 537.333 1742.56 539.145C1745.29 540.956 1747.32 543.511 1748.36 546.442V546.442C1748.65 547.297 1748.86 548.175 1748.99 549.063L1753.37 581.08V598.727C1753.36 603.057 1751.47 607.208 1748.12 610.273V610.273C1745.24 612.906 1741.46 614.561 1737.41 614.962L1680.95 620.584L1654.16 625.79L1637.05 635.168L1580.03 642.97L1223.01 655.55L999.784 660.743",
    stroke: "#00A8E2",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M959.1 559.477L630.56 567.884C625.494 568.016 620.469 567.017 615.923 564.971C611.377 562.926 607.447 559.897 604.476 556.149L570.19 512.939L455.582 412.478C455.582 412.478 408.468 370.226 405.983 367.226C404.25 364.951 402.857 362.476 401.84 359.865C399.239 353.465 397.934 346.687 397.988 339.861V320.348L393.997 220.354C393.997 210.402 392.997 187.9 388.997 177.5C383.997 164.5 381.497 108 382.997 102.5C384.497 97 382.997 92.5 382.997 87C382.997 81.5 382.997 60 382.997 58C382.997 56 382.002 52.5 379.502 44.5C377.002 36.5 377.002 18 377.002 11C377.002 5.4 377.002 -2 377.002 -5",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M993.833 551.548L997.257 519.695L982.938 220.354C983.126 226.569 982.301 223.9 977.501 163.5C971.501 88 975.501 55.5 970.501 41C966.501 29.4 968.834 -13.1667 970.501 -33",
    stroke: "#B9E4D5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M887.74 425.032L856.947 386.02L835.282 356.852L818.174 326.6C818.174 326.6 773.173 265.706 772.606 264.143C772.344 263.45 770.411 259.101 768.381 254.626C765.147 247.475 763.481 239.813 763.479 232.076V220.354C766.522 210.569 772.606 189.7 772.606 184.5C772.606 178 781.399 149.5 777.003 135.5C772.606 75 763.503 95.5 753.503 70C743.503 44.5 732.503 24.5 730.003 20C728.003 16.4 725.169 7.83333 724.003 4L718.003 -18",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 385.198C0.599952 386.809 35.7114 417.672 35.7114 417.672L77.8652 431.857L108.534 434L224.153 431.857H427.651L498.431 426.492L578.654 424.349L593.395 421.127L612.265 414.633H633.506L883.015 405.54L1025.79 399.643L1397.36 389.978L1592.02 384.107L1617.96 385.705L1637.43 387.835L1657.1 391.511C1659.31 391.927 1661.57 392.136 1663.84 392.135C1669.35 392.135 1674.78 390.899 1679.64 388.537L1724.13 366.922L1748.9 355.66L1768.97 344.567C1769.71 344.233 1770.52 344.042 1771.35 344.006C1772.17 343.97 1773 344.091 1773.77 344.359L1775.2 344.853C1776.32 345.246 1777.28 345.938 1777.96 346.838C1778.64 347.737 1779 348.802 1779 349.893C1779 351.327 1778.37 352.703 1777.26 353.719C1776.15 354.734 1777.26 355.66 1773 358L1762.5 360.349H1738.65",
    stroke: "#E8BBD6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.677 885.215L907.64 870.303H974.583",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1008.78 848.469L1022.42 885.213L1045.57 948.83L1059.58 961.611L1076.63 967.876H1094.95L1407.52 959.985L1644.22 953.015H1655.42",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1655.42 1081.32L1657.45 1058.49L1665.6 1024.57V993.439L1657.45 958.146L1649.82 932.595L1645.74 892.172L1641.6 848.495L1625.83 802.487L1614.63 760.198L1607.49 730.917L1589.17 686.308L1573.4 654.707L1556.6 615.216C1556.6 615.216 1547.94 577.111 1548.45 575.712C1548.96 574.313 1545.91 530.637 1545.91 528.784V463.238C1545.91 461.839 1548.96 401.474 1548.96 401.474L1557.11 348.975C1557.11 348.975 1563.72 314.576 1563.21 312.257C1562.7 309.937 1556.09 283.442 1556.09 283.442L1553.55 220.417C1553.55 191.278 1553.55 131.299 1553.55 124.499C1553.55 115.999 1557.11 85.999 1557.11 67.999C1557.11 49.999 1558.63 44.499 1556.09 31.499C1554.05 21.099 1553.55 3.83236 1553.55 -3.50098",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.15 283.404L1552.01 320.576L1543.86 361.933L1535.72 395.399L1532.67 422.815V564.544L1539.79 598.578L1552.01 637.514L1571.87 703.06L1588.66 749.534L1598.85 798.794L1616.66 851.735L1624.3 904.247L1632.44 960.969L1640.4 1007.72C1640.52 1008.46 1640.59 1009.2 1640.59 1009.95V1029.62C1640.59 1031.23 1640.29 1032.84 1639.71 1034.37C1638.63 1037.22 1636.6 1039.7 1633.9 1041.45C1631.21 1043.21 1627.98 1044.15 1624.67 1044.15H1530.11C1529.15 1044.15 1528.19 1044.23 1527.24 1044.38L1516.07 1046.2C1513.79 1046.58 1511.62 1047.39 1509.72 1048.6C1507.81 1049.8 1506.21 1051.36 1505.02 1053.17C1503.5 1055.48 1502.7 1058.11 1502.7 1060.8V1074.36L1501.18 1081.38L1492.01 877.726L1481.84 566.385L1475.29 376.605C1475.24 375.188 1474.96 373.786 1474.45 372.445L1471.29 364.076C1470.52 362.048 1469.26 360.207 1467.6 358.693C1466.07 357.296 1464.24 356.207 1462.22 355.497C1460.2 354.787 1458.04 354.472 1455.88 354.571L1417.21 356.349L1372.14 354.924C1363.19 354.652 1354.28 353.81 1345.45 352.403L1335.08 350.752C1315.93 347.693 1297.39 342.029 1280.08 333.95C1265.68 327.231 1250.56 320.084 1249.71 319.668C1248.19 318.736 1193.71 289.417 1192.18 289.001C1190.65 288.585 1136.7 262.039 1136.7 262.039L1045.57 220.367L1017 206.5L987.003 193C984.003 191 978.003 187.2 978.003 188",
    stroke: "#00A8E2",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.23 238.948L1091.39 368.905L1082.75 381.446L1079.68 391.644V407.942L1094.95 833.585L1105.64 1081.32",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.908 834.579L856.73 820.575L973.23 817.298",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1006.82 814.071L1351.52 806.18L1598.92 798.743H1623.93C1627.88 798.741 1631.77 797.789 1635.19 795.983L1635.41 795.869C1640.41 793.233 1644.12 788.947 1645.76 783.894C1646.76 780.823 1646.95 777.582 1646.34 774.428L1645.45 769.878C1644.99 767.456 1644.05 765.13 1642.69 763.008L1640.11 759.025C1637.8 755.469 1634.93 752.245 1631.59 749.458V749.458C1627.3 745.889 1621.7 743.912 1615.89 743.912H1602.52L1523.62 747.164L1227.35 757.386",
    stroke: "#B9E4D5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1475.29 376.617L1474.9 356.613L1472.14 310.126C1472.14 310.126 1474.9 243.408 1474.9 241.895V220.354C1474.9 205.069 1474.9 172.3 1474.9 163.5C1474.9 152.5 1469.38 141.5 1472.14 128.5C1474.35 118.1 1474.9 68.5 1474.9 45L1479 29.5C1479 26.3333 1479 19.6 1479 18C1479 16 1474.9 12.5 1474.9 8.5C1474.9 4.5 1472.14 -4 1472.14 -6.5",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1322.1 1081.32L1313.8 836.722L1308.26 697.248L1299.95 424.339L1290.55 220.354L1288 170C1288 159.833 1288 138.7 1288 135.5C1288 131.5 1288 84 1288 74.5C1288 66.9 1286 46 1285 36.5C1285 32.3333 1285 23.3 1285 20.5C1285 17.7 1285 3.66667 1285 -3",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1665.59 993.44L1515.87 999.969L1488.18 1003.2L1058.57 1013.1L1003.21 1016.14H968.884L916.288 1027.26L720.308 1033.32L436.852 1043.83L0 1057.07",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.606 1081.32L910.744 1025.2L890.708 992.57C886.691 986.035 881.868 979.941 876.334 974.406L851.479 949.587L830.85 923.659L566.781 931.222L369.806 939.301L201.511 943.348C201.511 943.348 3.12793 950.911 3.12793 949.411",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.856 923.656L783.37 889.295L766.261 877.724L751.859 858.186L735.704 832.031C733.201 827.971 730.103 824.244 726.494 820.951V820.951C721.501 816.392 715.613 812.732 709.137 810.161L626.011 777.237C623.205 776.125 620.178 775.55 617.118 775.548H562.755L447.912 690.162C447.912 690.162 379.327 634.07 378.719 632.558C378.553 632.104 377.338 631.512 375.833 630.906C370.665 628.923 365.065 628.06 359.47 628.386L240.857 634.587L0 641.646",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1641.67 848.469L1491.19 852.743L1231.95 860.154",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1527.25 1044.32L1321.02 1049.39L1104.54 1055.48L1014.24 1058.71L1008.78 1061.73",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.96 481.502L1161.74 231.5C1158 193 1165.94 200.5 1161.74 164.5C1157.55 128.5 1155.83 48.8333 1155.5 13.5V-7",
    stroke: "#B9E4D5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.867 467.952L566.105 465.154L640.684 463.44L892.781 456.406L985.904 453.167L1300.57 444.784L1547.28 436.238",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398 306C398 306 415.5 301.831 451 303.916C486.5 306 506 309 506 309L566.105 303.916L640.684 302.201L892.781 295.168L985.904 291.928L1300.57 283.546C1396.91 280.209 1459.65 278.337 1556 275",
    stroke: "#B9E4D5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1553.5 215.034C1553.5 215.034 1547.51 218.905 1530.02 216.27C1512.53 213.635 1503 215.011 1503 215.011L1473.09 214.48L1436.15 215.034L1311.25 218.143L1265.1 219.933L1109.21 223.418C1061.45 225.255 1030.36 226.15 982.608 227.988",
    stroke: "#B9E4D5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1545.97 487.4L1479.21 490.451",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.92 498.244H1210.11L1216.6 494.816C1217.65 494.257 1218.84 493.95 1220.05 493.921L1281.67 492.408C1283.22 492.371 1284.75 492.705 1286.11 493.379L1290.55 495.585H1302.12L1390.17 493.48L1399.08 492.408",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1210.12 498.241L1216.59 501.127C1217.65 501.608 1218.82 501.841 1220 501.808L1282.65 500.156C1284 500.134 1285.33 499.826 1286.52 499.258C1287.72 498.689 1288.76 497.875 1289.55 496.879L1290.6 495.619",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.672 817.297L914.173 715.021L908.47 560.762L906.343 508.741L817.998 510.695L730.247 513.395",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.789 504.506L1083.05 501.809",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1553.27 158.453L1451 161.15",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.11 451.807L1039.21 503.159",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497 215L1495 160",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.07 512.967V526.958H1043.1L1042.61 502.883",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1500.98 149.992L1500.98 136.001L1490.96 136.001L1491.44 160.076",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.59 532.969L1021.82 557.927",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.511 588.782L1064.28 587.761L1063.79 562.11",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1141.63 554.082C1141.63 554.082 1144.98 640.766 1144.98 641.056C1144.98 641.346 1145.85 666.707 1145.85 666.707L1147.34 708.48",
    stroke: "#00A8E2",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.33 760.498L1164.03 759.036H1168.71C1169.94 759.034 1171.15 759.339 1172.21 759.919V759.919C1172.99 760.351 1173.67 760.925 1174.2 761.606C1174.73 762.287 1175.11 763.059 1175.3 763.876L1176.03 766.927C1176.12 767.308 1176.17 767.696 1176.18 768.086L1176.87 794.103C1176.9 794.9 1176.81 795.696 1176.61 796.473L1175.49 800.746C1175.2 801.851 1174.69 802.898 1173.99 803.834L1172.36 806.027C1171.85 806.723 1171.23 807.35 1170.54 807.893C1169.32 808.836 1168.37 810.025 1167.75 811.364C1167.13 812.704 1166.87 814.157 1166.97 815.607L1169.35 847.321",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.85 822.792H1150.44V810.78",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1162.19 810.519V828.897L1158.85 833.309V844.263H1152.53V833.422L1158.85 833.309",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.06 809.343V818.28L1209.54 821.494L1210.13 850.586L1204.53 856.914V865.838L1202.18 872.733V894.993",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.21 859.665L1248.34 836.698L1257.17 836.131",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.88 856.185L1372.14 876.466C1372.18 877.232 1372.54 877.955 1373.13 878.495L1374.15 879.428C1374.47 879.721 1374.84 879.953 1375.26 880.111C1375.67 880.269 1376.12 880.35 1376.57 880.348H1377.51C1378.01 880.349 1378.5 880.249 1378.96 880.056C1379.41 879.862 1379.81 879.578 1380.13 879.226V879.226C1380.7 878.607 1380.98 877.812 1380.92 877.008L1379.26 855.895",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1372.88 855.945V848.471L1371.47 845.08L1370.39 832.878L1369.3 824.004L1368.47 805.336",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.19 805.336V826.046H1369.54",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1370.88 836.976L1402.31 835.842",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390.5 836.269V845.092C1390.49 845.524 1390.39 845.951 1390.22 846.353L1390.12 846.567C1389.78 847.385 1389.12 848.058 1388.26 848.458V848.458C1387.66 848.747 1386.98 848.886 1386.3 848.861L1372.88 848.408",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.34 812.318L1432.12 811.637L1431.79 803.759",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.55 852.2L1510.23 848.973C1510.18 848.376 1509.89 847.817 1509.42 847.397C1509.16 847.158 1508.85 846.967 1508.51 846.837C1508.18 846.707 1507.81 846.641 1507.44 846.641H1503.74C1503.1 846.642 1502.46 846.475 1501.92 846.16C1501.37 845.846 1500.93 845.396 1500.65 844.864V844.864C1500.45 844.468 1500.34 844.039 1500.32 843.603L1499.59 809.57H1503.95C1504.68 809.565 1505.4 809.382 1506.04 809.04C1506.96 808.547 1507.64 807.748 1507.93 806.809L1508.04 806.482C1508.16 806.072 1508.21 805.645 1508.18 805.221L1507.9 801.44",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1506.04 809.067L1507.44 846.642",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580.03 850.219L1582.2 900.828L1583.94 954.79",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.34 759.24L1157.68 771.845L1158.1 788.408L1162.25 790.576C1162.25 790.576 1167.55 792.176 1167.55 791.723C1167.55 791.269 1167.05 771.845 1167.05 771.845H1157.75",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.94 867.97L1096.32 865.248",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1050.13 866.723L1049.14 854.736L1011.32 855.316",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945.412 842.065L949.541 844.8L974.575 844.258",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1043.38 777.304L1045.11 813.19",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.95 813.011L1051.51 769.423L1049.32 767.419L1045.12 765.188H1036.75L1033.93 762.629L1032.75 722.356",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.24 711.871C1043.99 711.871 1045.11 765.202 1045.11 765.202",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.98 722.371H1083.55",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.16 711.718L1049.63 706.538C1049.73 705.542 1050.22 704.614 1051.01 703.916L1052.57 702.504C1052.9 702.195 1053.28 701.939 1053.7 701.748L1054.23 701.496C1054.91 701.172 1055.67 701.009 1056.44 701.022C1057.21 701.036 1057.96 701.224 1058.63 701.571V701.571C1059.49 702.023 1060.16 702.711 1060.56 703.538L1061.94 706.45C1062.1 706.782 1062.21 707.129 1062.28 707.483L1062.92 711.265",
    stroke: "#B9E4D5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1000.49 675.431L1039.37 674.737L1044.66 671.082L1051.76 659.536",
    stroke: "#B9E4D5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.37 697.123C1033.99 696.897 1030.87 689.359 1030.87 689.359L1032.63 680.687L1039.36 674.788",
    stroke: "#B9E4D5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.31 658.728L1080.43 663.316L1081.17 679.652L1083.37 682.614L1089.58 683.521",
    stroke: "#B9E4D5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.9 581.323C1085.9 581.437 1133.96 580.176 1133.96 580.176",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1109.94 555.103V564.405L1098.7 564.847C1098.44 564.861 1098.18 564.908 1097.94 564.985V564.985C1097.52 565.123 1097.14 565.358 1096.85 565.667C1096.55 565.976 1096.35 566.349 1096.26 566.75L1096.12 567.33C1096.1 567.518 1096.1 567.708 1096.12 567.897L1097.1 593.485C1097.11 593.746 1097.15 594.004 1097.24 594.254L1097.62 595.514C1097.77 596.006 1098.05 596.458 1098.43 596.833C1098.81 597.208 1099.28 597.495 1099.8 597.67V597.67C1100.25 597.814 1100.71 597.883 1101.18 597.872L1131.05 596.447C1131.84 596.405 1132.58 596.087 1133.12 595.558C1133.66 595.03 1133.95 594.332 1133.94 593.611L1133.37 567.216C1133.38 567.036 1133.38 566.855 1133.37 566.674V566.674C1133.21 565.89 1132.75 565.185 1132.07 564.686C1131.38 564.186 1130.53 563.926 1129.66 563.952L1124.92 564.09L1110.02 564.431",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.06 572.864L1133.45 572.17",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1096.86 588.796C1096.86 588.519 1133.97 587.939 1133.97 587.939",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.8 606.215L1143.58 604.728",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.82 555.091V546.015H1092.66",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.76 656.762L1167 553.263L1165.87 546.595L1164.59 521.007C1164.53 519.723 1163.95 518.506 1162.94 517.604V517.604C1162.4 517.109 1161.75 516.721 1161.04 516.463C1160.33 516.205 1159.57 516.083 1158.8 516.104L1124.1 516.936C1123.26 516.948 1122.43 517.175 1121.72 517.591V517.591C1121.03 517.989 1120.46 518.549 1120.08 519.213C1119.69 519.878 1119.51 520.623 1119.54 521.373L1121.06 554.801",
    stroke: "#00A8E2",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364.22 321.661L1360.46 218.162L1359.33 211.494L1358.05 185.906C1357.99 184.622 1357.41 183.404 1356.4 182.502V182.502C1355.86 182.008 1355.21 181.619 1354.5 181.361C1353.79 181.104 1353.03 180.981 1352.26 181.002L1317.56 181.834C1316.72 181.846 1315.89 182.073 1315.19 182.49V182.49C1314.49 182.888 1313.92 183.447 1313.54 184.112C1313.15 184.776 1312.97 185.521 1313 186.271L1314.52 219.699",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.77 525.925C1120.32 525.698 1164.77 524.664 1164.77 524.664",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.23 190.823C1313.78 190.596 1358.23 189.562 1358.23 189.562",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.58 509.473H1218.53L1223.01 511.301V521.322C1223.01 521.864 1223.14 522.399 1223.41 522.885L1224.08 524.082C1224.4 524.638 1224.87 525.104 1225.46 525.428C1226.04 525.753 1226.71 525.924 1227.4 525.922V525.922C1227.92 525.921 1228.44 525.817 1228.92 525.617C1229.39 525.417 1229.82 525.125 1230.16 524.763C1230.42 524.46 1230.62 524.17 1230.57 523.981C1230.45 523.401 1230.57 511.074 1230.57 511.074L1222.95 511.301",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1302.53 508.906L1280.44 509.322L1272.57 509.473L1273.19 523.641C1273.19 523.641 1280.95 523.868 1280.95 523.641C1280.95 523.414 1280.44 509.322 1280.44 509.322",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.69 515.411H1302.53",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.47 549.104L1278.22 558.129L1275.91 572.687C1275.79 573.489 1275.75 574.299 1275.79 575.108L1276.94 596.876C1276.96 597.31 1277.07 597.736 1277.25 598.137V598.137C1277.55 598.745 1278.02 599.267 1278.62 599.644C1279.22 600.02 1279.92 600.236 1280.65 600.267L1297.08 601.036C1297.6 601.063 1298.12 601.135 1298.63 601.25V601.25C1300.01 601.582 1301.27 602.259 1302.26 603.204L1305.49 606.317",
    stroke: "#E8BBD6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1315.52 584.852L1314.26 557.436H1326.28V548.197",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1341.4 547.743L1342.04 558.697L1333.53 581.31V594.785",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.34 634.428H1337.03V641.386L1306.61 642.873",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 220H1415V225.767L1384.26 227",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.27 642.201L1320.76 652.121",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1398 226V236",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.04 630.887L1357.72 650.84",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1435 217V234",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.94 640.853H1383.7L1382.99 628.135",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456 225H1461L1460.39 214",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1383.69 632.713H1395.09",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461 218H1473",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.04 630.883L1462.9 630.215C1463.55 630.211 1464.2 630.357 1464.77 630.642C1465.35 630.926 1465.83 631.339 1466.19 631.841C1466.57 632.409 1466.78 633.064 1466.78 633.732V639.215",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404.72 630.883V637.11C1404.72 637.816 1404.94 638.507 1405.35 639.102C1405.74 639.632 1406.27 640.065 1406.88 640.36C1407.5 640.656 1408.19 640.804 1408.89 640.791L1455.12 639.304C1455.95 639.275 1456.77 639.043 1457.47 638.634C1458.18 638.224 1458.75 637.65 1459.14 636.972V636.972C1459.53 636.26 1459.71 635.461 1459.63 634.665L1459.25 630.215",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1454.26 591.936L1476.03 594.785L1485.3 594.218L1538.64 592.73",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1507.43 593.597L1505.07 542.85",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1482.03 572.274L1524.71 571.266",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.29 579.137L1524.71 578.457",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1488.29 586.678L1524.71 586.224",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1490.92 547.502L1491.68 563.611L1524.71 562.805",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1521.46 546.352L1522.2 562.865",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.7 546.352L1514.45 563.054",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1497.05 547.476C1496.93 548.056 1497.81 563.585 1497.81 563.585",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510.8 489.015V494.17L1518.82 499.414",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1456.13 452.108V439.403",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1476.47 411.013L1387.36 413.975L1382.99 415.009L1247.31 419.118H1232.8L1214.79 416.95L1193.27 417.983",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.62 435.294V425.702H1300",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1300.06 427.818L1310.72 427.062C1311.48 427.006 1312.25 427.103 1312.96 427.344C1313.68 427.586 1314.33 427.967 1314.86 428.461V428.461C1315.36 428.904 1315.75 429.432 1316.01 430.015C1316.28 430.597 1316.41 431.221 1316.41 431.852V444.242",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 434.335L1341.53 433.251C1342.04 433.223 1342.55 433.294 1343.02 433.459C1343.5 433.624 1343.93 433.88 1344.29 434.209C1344.9 434.775 1345.27 435.522 1345.33 436.314L1345.82 443.222",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.04 424.729C1357.04 425.07 1358.03 432.292 1358.03 432.292L1363.55 437.259L1363.97 442.616",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.27 417.129V392.638",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.03 392.195V411.935H1313.27",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359 200L1378.74 200L1378.74 216.764",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1313.27 398.918H1330.03",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365.73 216.764L1365.73 200",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.63 398.918L1322.09 412.393",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1365.73 208.396L1379.2 207.941",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1339.04 391.957L1336.53 359.386C1336.19 352.257 1335.5 337.499 1335.5 335.499C1335.5 333.499 1343.84 332.999 1348 332.999C1352.34 332.999 1361.4 332.999 1363 332.999C1364.6 332.999 1364.17 325.832 1364 321.499",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.85 373.669L1337.44 371.148",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.25 355.616L1308.22 372.204",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1316.38 357.344C1316.76 357.685 1317.39 371.878 1317.39 371.878",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.39 363.913H1330.52",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.97 374.917L1452.51 373.669V388.568",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1452.53 373.669V368.916C1452.52 368.014 1452.13 367.15 1451.44 366.509V366.509C1451.03 366.142 1450.54 365.865 1450.01 365.699C1449.47 365.533 1448.89 365.482 1448.33 365.551L1409.98 370.013H1395.62V381.093L1452.55 380.261",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.49 389.398L1426.17 402.634C1426.21 403.416 1426.47 404.175 1426.93 404.839V404.839C1427.4 405.536 1428.07 406.104 1428.86 406.485C1429.66 406.867 1430.55 407.047 1431.44 407.008L1476.47 405.079",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1467.01 411.333L1467.79 439.001",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1436.74 440.069V434.888L1433.74 429.859V421.641V412.439",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1433.75 429.861L1417.73 430.315V421.643H1433.75",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.63 412.645V421.645",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.59 420.154L1398.22 421.641",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324.77 495.04L1324.27 487.401H1312.38V465.721L1315 456.128H1328.02L1344.91 454.868L1373.19 451.099H1379.07L1379.82 486.053L1374.31 486.506",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.55 493.858L1373.19 451.115",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1338.65 494.7V486.053L1343.78 485.914L1355.54 485.599L1354.79 469.956L1343.78 470.359L1333.27 470.75V486.166L1338.65 486.053",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1343.77 485.916V470.361",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1328.02 456.127V443.825",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.25 654.621L1250.16 664.515H1241.38C1240.9 664.514 1240.42 664.599 1239.98 664.765C1239.54 664.932 1239.13 665.177 1238.8 665.486V665.486C1238.46 665.794 1238.19 666.159 1238.01 666.562C1237.83 666.964 1237.73 667.395 1237.73 667.831V678.444",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.3 653.547L1281.55 674.736",
    stroke: "#E8BBD6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.79 662.081H1263.25L1264.15 675.43L1283.68 674.736L1287.22 676.186L1288.48 703.98",
    stroke: "#E8BBD6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1330.36 652.123L1332.5 702.593",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1408 236L1410 280",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.71 683.965L1316.7 684.608L1317.41 694.175L1332.1 693.204",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1409.6 263L1394 263.567L1394.73 272L1410 271.144",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.65 676.174H1419.82V700.817",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1396.23 664.148C1396.23 663.883 1421.95 664.148 1421.95 664.148",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1459.67 698.899C1459.58 698.899 1461.36 729.819 1461.36 729.819",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1523.48 645.039L1524.71 655.438L1528.09 664.136L1531.76 667.488L1532.71 696.013",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213 222L1212.01 193.662L1208.21 190.331L1204.71 181.691L1203.44 171.36C1199.27 169.042 1191.47 167.883 1186.29 167.883C1175.94 167.883 1164.04 165.896 1163 167.883",
    stroke: "#B9E4D5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1539.63 654.961L1496.41 656.423V678.242C1496.42 678.922 1496.51 679.6 1496.69 680.259V680.41C1497.01 681.524 1497.6 682.561 1498.41 683.449C1499.21 684.337 1500.22 685.055 1501.36 685.553V685.553C1502.62 686.107 1504.01 686.375 1505.42 686.335L1549.48 684.935L1539.63 654.961Z",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1220.22 180.922L1177 182.384V204.203C1177 204.883 1177.09 205.56 1177.28 206.22V206.371C1177.6 207.485 1178.19 208.522 1178.99 209.41C1179.8 210.298 1180.8 211.016 1181.94 211.514V211.514C1183.21 212.068 1184.6 212.336 1186 212.296L1230.07 210.896L1220.22 180.922Z",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.45 665.334L1542.63 664.023",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.04 191.295L1223.21 189.984",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496.45 676.172L1545.97 674.08",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1177.04 202.133L1226.56 200.041",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1511.41 696.935V748.287",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1554.03 643.969C1554.03 643.969 1559.86 653.347 1560.04 653.826C1560.22 654.305 1566.83 664.704 1566.83 664.704L1569.07 669.456C1569.59 670.551 1570.33 671.547 1571.25 672.393C1572.21 673.269 1573.35 673.964 1574.6 674.437C1575.86 674.911 1577.2 675.154 1578.56 675.153H1579.8L1584.19 676.099",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1604.76 639.215C1604.76 639.215 1610.44 629.661 1610.44 628.942V611.207",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1628.44 636.416C1628.72 635.521 1637.07 624.341 1637.07 624.341V610.563",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1610.46 626.434L1682.75 620.497",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1671.7 621.403L1670.98 608.294",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.855 407.033L882.405 456.684",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.089 408.229L822.755 666.542L825.089 769.222L797.693 782.936",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.648 454.198V439.211C956.646 438.566 956.802 437.929 957.104 437.346L957.891 435.858C958.246 435.188 958.784 434.612 959.454 434.188C960.125 433.764 960.904 433.506 961.716 433.438V433.438C962.414 433.373 963.12 433.453 963.779 433.671C964.439 433.889 965.037 434.24 965.527 434.698L965.831 434.976C966.704 435.777 967.199 436.858 967.212 437.988V446.812L975.98 445.476L977.444 439.614L993.392 438.228",
    stroke: "#B9E4D5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.742 294.001L904.742 308.988C904.744 309.633 904.588 310.271 904.286 310.854L903.499 312.341C903.145 313.012 902.606 313.587 901.936 314.011C901.266 314.435 900.487 314.694 899.674 314.761V314.761C898.976 314.826 898.271 314.747 897.611 314.528C896.951 314.31 896.354 313.959 895.863 313.501L895.56 313.223C894.687 312.422 894.191 311.341 894.179 310.211L894.179 301.387L885.411 302.724L883.947 308.585L867.998 309.971",
    stroke: "#B9E4D5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.645 460.426L970.384 482.321H995.46",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.792 468.721H994.821",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004.59 463.892V452.674",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.82 463.892C1014.53 462.027 1014.82 452.674 1014.82 452.674",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524 204C1524.29 205.866 1524 215.219 1524 215.219",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.35 462.56V452.123",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510 205.001L1510 215.438",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.69 451.115L1060.44 501.812",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1039.21 489.256H1045.58L1059.56 494.701H1071.55L1074.7 497.588",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1495 174L1487.29 174L1470.34 168.118L1455.81 168.118L1452 160.5",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020.59 503.157V495.317L1025.36 494.699",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.47 159.802L1513.47 167.642L1508.69 168.26",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.74 449.98L1104.3 489.257",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.73 475.099L1129.69 474.116",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1123.6 397.59L1125.96 449.434",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1249.29 470.361L1252.89 467.071V461.387L1250.34 459.055V452.097L1252.66 449.979L1252.48 446.059",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1252.65 449.98L1254.97 452.098L1255.35 458.98L1252.89 461.387",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1703.02 536.358L1706.74 618.101",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1688.1 562.868H1704.24",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1745.5 543.306H1729.38L1722.08 545.322L1717.16 550.364L1714.95 560.133L1720.39 567.873L1736 580.894C1736 580.894 1742.91 584.763 1743.46 584.763C1744.01 584.763 1753.32 587.398 1753.32 587.398",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1720.39 567.934L1715.97 573.354L1716.83 590.094",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1758.67 628.943H1708.15L1637.01 635.245L1633.65 638.006L1605.79 650.838C1605.79 650.838 1596.49 664.943 1596.03 665.333L1617.61 655.754L1634.18 654.959L1663.3 652.312",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1614.87 638.234C1616.03 638.07 1662.58 652.099 1663.37 652.263C1664.15 652.427 1707.75 652.982 1707.75 652.982L1749.17 648.734C1754.48 648.194 1759.82 647.925 1765.16 647.927H1773.72C1781.94 647.926 1790.14 648.571 1798.23 649.856L1815.17 652.54C1823.1 653.8 1830.9 655.668 1838.48 658.124L1873.45 669.469L1899.21 681.406L1918.63 690.229",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1617.6 655.742L1622.75 657.91L1623.93 664.024V666.419",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670.09 652.492V721.428L1668.31 725.777L1664.17 727.226L1644.35 725.777H1640.67L1637.02 729.029L1634.84 735.546V748.314L1641.74 759.419L1658.31 787.629L1673.3 798.079C1675.05 799.301 1677.04 800.211 1679.16 800.764L1685.5 802.402C1687.06 802.805 1688.66 803.009 1690.28 803.007H1700.29C1700.84 803.007 1701.38 803.007 1701.93 803.07L1718.32 804.482C1719.53 804.595 1720.74 804.595 1721.94 804.482C1725.29 804.129 1728.67 804.668 1731.69 806.032L1756.79 817.377L1779.77 826.957L1786.51 829.137H1796.17L1801.92 825.52L1826.88 779.108L1822.92 758.776L1837.48 730.252L1839.66 731.159L1844.02 723.205L1840.44 720.848L1847.18 708.016L1855.47 713.222L1849.72 725.008L1843.98 723.205",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1839.7 731.17L1843.55 734.977L1829.4 764.372L1825.06 769.93",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1773.69 824.357C1774.16 824.546 1787.68 824.357 1787.68 824.357L1806.22 817.261",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1794.82 821.62C1795.13 821.506 1800.45 821.62 1800.45 821.62L1802.88 824.431L1801.83 831.401C1800.48 832.345 1799.06 833.212 1797.59 833.998C1797.36 833.922 1792.15 833.998 1792.15 833.998L1786.78 831.099L1777.72 826.057",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1792.16 833.987V838.814L1779.55 866.722L1773.46 867.238L1767.27 866.129L1761.98 863.457L1754.6 856.411L1748.89 854.848L1742.96 856.562",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670.11 662.407H1630.53L1627.32 665.319",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1670.98 657.772C1671.53 658.062 1696.17 657.772 1696.17 657.772V652.882",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1594.72 744.228L1578.15 699.027V695.183L1581.69 691.956L1586.41 695.183L1601.35 732.569L1605.82 743.913C1605.82 743.913 1611.8 777.505 1611.8 777.947C1611.8 778.388 1613.82 787.955 1613.82 787.955L1612.13 791.031H1606.61L1603.85 788.51L1596.12 753.342L1598.59 746.636L1599.76 743.976",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.31 722.61V738.87L1622.98 744.933",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1632.99 723.493C1633.16 724.111 1634.83 748.287 1634.83 748.287",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1633.9 796.614C1635.19 795.984 1642.6 792.896 1642.77 792.429C1644.97 790.73 1647.28 789.139 1649.67 787.665H1654.39L1660.05 788.925",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1542.8 746.369L1545.05 767.671C1545.13 768.452 1545.51 769.183 1546.11 769.739L1546.4 770.016C1546.94 770.499 1547.62 770.824 1548.36 770.948C1549.1 771.071 1549.86 770.988 1550.55 770.709C1551.21 770.444 1551.77 770.008 1552.16 769.454C1552.55 768.901 1552.75 768.254 1552.74 767.596C1552.74 765.377 1552.74 762.226 1552.74 761.646C1553.1 758.81 1552.74 745.953 1552.74 745.953",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1547.85 777.19C1548.37 777.656 1549.03 800.244 1549.03 800.244",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1611.08 798.73L1608.39 803.041L1619.68 836.583L1622.04 842.129L1625.75 843.352L1629.79 841.36L1630.63 836.898L1618.16 801.466L1615.17 798.73",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625.74 843.351L1626.75 848.897",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.62 848.898L1625.74 854.306L1630.63 892.436L1633.08 894.667H1637.72L1640.66 891.364L1635.52 851.507L1634.83 848.469",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1631.47 899.772L1634 926.76L1636.53 943.07L1639.99 946.222L1647.49 944.961V940.499L1643.1 934.499C1643.1 934.499 1641.6 915.592 1641.6 915.113C1641.6 914.634 1640.66 899.356 1640.66 899.356",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651.68 994.046L1648.82 988.777L1644.96 981.693C1644.96 981.693 1640.55 961.689 1640.65 961.223C1640.75 960.756 1643.3 958.802 1643.3 958.802L1648.33 957.542L1651.68 962.584L1655.41 980.13C1655.41 980.13 1656.58 985.059 1656.79 985.512C1657 985.966 1653.59 994.021 1653.59 994.021L1656.81 1000.32L1658.48 1029.87L1664.87 1027.73L1670.79 1033.65H1703.16L1747.15 1031.65L1763.34 1029.5C1763.34 1029.5 1768.65 1031.89 1768.22 1032.73C1767.8 1033.57 1766.71 1039.2 1766.71 1039.2C1766.71 1039.2 1751.88 1045.35 1751.03 1045.5C1750.19 1045.65 1732.83 1047.65 1732.83 1047.65L1716.48 1046.39L1705.52 1044.25L1699.11 1039.94",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1662.59 1037.13L1692.33 1040L1741.38 1038.57L1767.29 1036.18",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673.98 1038.24L1677.5 1043.39L1684.91 1045.85L1689.08 1042.04L1690.64 1039.84",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1645.79 1081.32C1645.79 1081.32 1649.49 1068.94 1649.33 1068.48C1649.16 1068.01 1645.79 1050.93 1645.79 1050.93L1637.87 1042.94L1634.66 1040.01",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565.57 1081.32L1563.37 987.844L1561.67 955.45",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.87 854.154L1442.86 870.288H1478.76V865.12L1475.9 862.284H1458.53L1445.39 862.964V873.578L1448.43 876.351H1478.8V870.288",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460.3 905.456C1460.55 904.611 1460.3 880.41 1460.3 880.41H1468.13L1469.65 905.09",
    stroke: "#E8BBD6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1464.99 1003.77V1038.14L1458.08 1038.27",
    stroke: "#E8BBD6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1458.02 1045.85L1456.67 1011.54H1464.98",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.25 880.396L1231.95 883.699L1235.89 894.678V908.178L1230.06 913.9",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.44 911.51C1284.44 911.51 1281.53 871.893 1282.98 870.305C1284 869.24 1285.09 868.227 1286.24 867.267C1286.74 866.848 1287.4 866.626 1288.07 866.649C1288.74 866.669 1289.37 866.924 1289.84 867.362C1290.3 867.8 1290.56 868.385 1290.56 868.994V882.771L1292.06 911.762",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.06 859.421V866.644",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1275.66 912.364V889.221L1257.73 890.368V904.02H1267.82H1275.66",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1267.83 890.117L1267.82 904.021",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1283.84 903.112L1291.6 902.684",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.7 912.893L1261.44 963.678",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.49 935.257H1266.7L1269.21 933.014L1267.85 916.514L1275.67 916.098L1277.23 932.421L1269.21 933.014",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.78 963.791L1259.16 1004.72L1256.78 1004.97V998.644L1253.04 996.224L1251.67 995.228L1250.86 973.484H1257.35",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1296.01 1007.63L1296.94 1032.04L1256.23 1033.54L1255.6 1017.63H1263.08L1264.54 1014.55L1263.99 1008.36",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1260.63 1008.45L1261.16 1017.63",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1263.08 1017.63L1264.09 1033.25",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.23 1013.63L1281.15 1032.63",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1288.26 1008.45L1289.35 1032.32",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.2 1025.2L1317.64 1034.74L1313.86 1038.2L1302.81 1041.49L1271.7 1042.41H1234.06L1208.96 1036.11L1162.99 1025.2L1150.71 1022.34C1148.32 1021.79 1145.87 1021.43 1143.41 1021.28L1132.83 1020.69C1131.04 1020.58 1129.24 1020.58 1127.45 1020.69L1112.53 1021.71L1095.47 1023.37L1087.97 1023.83C1085.62 1023.97 1083.25 1023.9 1080.91 1023.64L1078.29 1023.34C1074.14 1022.87 1070.1 1021.76 1066.36 1020.06L1055.13 1015.02L1045.62 1006.19C1041.25 1002.16 1037.92 997.296 1035.84 991.95L1020.65 952.762L1005.59 916.939L998.823 892.989C998.232 890.885 997.881 888.731 997.773 886.561L996.641 862.158C996.466 858.509 996.553 854.854 996.903 851.216L998.049 839.355",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.375 672.529L965.924 662.344",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.428 609.293L503.069 624.81",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.18 989.353L1082.98 967.874",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.19 976.184L1090.99 987.339H1101.59",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.1 966.161L1164.11 976.182L1167.12 991.371V1001.97H1177.93L1179.53 1085",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.11 993.44H1184.75",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.56 965.293L1198.57 999.226L1200.97 1004.97L1202.17 1009.8",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204.77 965.291L1205.78 1009.79",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1181.74 935.257C1182.33 934.677 1213 934.135 1213 934.135",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.86 914.91V934.41",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1321.61 1067.07L1375.85 1065.25L1377.86 1062.5V1056.1V1031.05H1368.63V1048.22",
    stroke: "#E8BBD6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.19 1066.61C1335.01 1066.61 1332.09 1063.79 1332.09 1063.79V1058.67L1336.39 1057.08L1394.69 1055.92L1397.28 1058.31L1398.08 1081.32",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1389.68 1055.92L1387.18 1058.21L1388.43 1081.32",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.85 1062.5V1073.85L1381.87 1077.5H1389.67",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.07 1042.45L1227.6 1045.31L1208.98 1042.45L1169.72 1033.26L1144.47 1027.21L1123.03 1025.58L1111.42 1027.21L1086.98 1033.54L1075.16 1040.38L1064.74 1048.25L1044.71 1070.37L1041.1 1081.32",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.17 1040.38L1092.67 1034.89L1108.23 1031.05H1120.64L1133.07 1033.54L1164.51 1045.13L1193.77 1060.31L1220.61 1070L1244.45 1072.02L1300.13 1079.51L1317.77 1083.17",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.48 1027.21L1173.34 1040.01L1200.99 1055.92L1222.02 1067.06L1244.45 1072.02",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.16 1082.45L1208.39 1072.02L1175.92 1057.11L1152.28 1047.5L1126.45 1041.11L1109.82 1038.92L1090.19 1038L1067.75 1034.89L1050.32 1027.21L1037.1 1010.75L1027.08 987.341L992.716 905.119",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060.72 1081.32C1060.93 1079.88 1071.55 1064.15 1071.55 1064.15L1082.15 1053.45L1095.88 1046.78L1109.6 1044.26L1136.25 1048.36L1163.08 1060.61L1194.44 1073.21L1212.99 1079.81L1226.6 1084.92",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.72 1038.94C1030.72 1038.94 1021.53 1020.03 1021.15 1017.64C1020.78 1015.24 1001.2 960.363 1000.54 959.443C999.876 958.523 986.897 920.91 986.248 919.699C985.599 918.489 974.58 883.296 974.58 883.296",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.46 1064.66L1022.14 1042.41L1008.77 1001.27L996.552 967.839L985.906 934.65L985.312 917.028",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M922.746 931.246L933.102 926.305C933.968 925.893 934.888 925.515 935.864 925.171C941.199 923.205 947.032 922.65 952.696 923.57V923.57C953.345 923.671 953.98 923.797 954.616 923.948L966.96 926.709L977.261 931.272L1010.93 929.759L1036.42 923.683C1036.64 924.288 1060.79 918.641 1060.79 918.641L1180.37 915.604L1316.31 911.041L1511.99 903.478L1646.46 899.343",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M943.003 957.187H970.288L1060.79 918.604",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.569 973.458L1047.24 970.899L1076.63 967.874V989.353",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.965 924.665L956.667 897.06L948.024 894.993L947.471 876.703",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.043 870.303L941.239 873.139C942.385 874.613 944.022 875.709 945.906 876.265L947.991 876.87C949.946 877.446 952.056 877.406 953.983 876.757V876.757C955.235 876.327 956.369 875.654 957.306 874.783C958.244 873.912 958.962 872.865 959.41 871.715L959.99 870.253",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.512 900.69L914.874 890.153C915.295 889.868 915.761 889.643 916.255 889.485L916.504 889.409C917.714 889.045 919.024 889.067 920.218 889.472V889.472C920.709 889.632 921.173 889.853 921.599 890.128L923.974 891.728L925.024 893.72L908.702 905.064",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.973 891.718L931.346 891.403",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M905.68 896.069L897.022 885.216L901.358 882.67L909.685 893.497",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.362 796.325L862.707 802.817C862.707 802.817 865.689 806.334 865.689 806.598V820.703",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M935.722 803.37L936.247 818.332",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M939.761 785.583H955.295L961.868 788.394H972.183",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.342 765.163L827.088 769.41L815.157 768.125L798.228 768.528L792.166 769.41L787.223 773.923",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.291 767.872L880.009 787.901L860.18 789.111",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.546 765.996L757.677 756.505L760.48 719.988",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.582 719.346V737.611L781.548 739.842L824.368 737.976",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.582 730.07L815.6 729.188V738.364",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.373 749.295H824.626",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M774.531 749.699L770.997 768.921",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.626 743.371L844.634 743.698L847.092 745.211V751.299",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.083 725.825L840.252 725.031L840.777 717.393",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.243 734.799L937.379 736.009L935.722 714.328",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.915 708.201L918.968 705.806H939.943L941.821 707.52V714.125",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.821 706.601L944.467 703.286H959.062L958.551 690.026",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M871.386 664.703C871.386 665.195 872.532 688.413 872.532 688.413",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M913.157 687.533H904.513C903.112 687.536 901.718 687.714 900.37 688.062C899.416 688.304 898.49 688.633 897.609 689.045L892.292 691.478C890.328 692.372 888.163 692.838 885.968 692.839H876.882C875.747 692.84 874.615 692.713 873.513 692.461L868.887 691.428C867.127 691.036 865.307 690.913 863.502 691.062V691.062C862.81 691.124 862.112 691.064 861.445 690.886L860.782 690.722L860.437 690.608L854.002 688.503C853.846 688.459 853.694 688.404 853.546 688.339L852.069 687.709C850.95 687.242 849.695 687.118 848.493 687.356V687.356C847.139 687.634 845.945 688.356 845.137 689.386L844.902 689.688C844.724 689.917 844.525 690.132 844.309 690.331L844.157 690.47C843.399 691.159 842.441 691.636 841.395 691.844L835.237 693.104C834.867 693.181 834.506 693.291 834.16 693.432L831.578 694.503L823.431 694.907L805.204 696.823L799.031 695.991C797.627 695.799 796.241 695.504 794.889 695.108L785.458 692.285C784.602 692.033 783.732 691.818 782.848 691.642L777.187 690.558C776.172 690.357 775.143 690.218 774.108 690.142V690.142C770.283 689.851 766.437 690.369 762.868 691.655L759.057 693.079L750.371 695.953L741.064 698.196L737.212 697.642H735.583",
    stroke: "#B9E4D5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.343 691.842C842.404 691.652 843.48 691.534 844.56 691.489C845.125 691.453 845.69 691.549 846.203 691.766L846.963 692.106C847.222 692.218 847.496 692.299 847.777 692.346L848.302 692.434C848.82 692.523 849.354 692.494 849.857 692.351C850.359 692.209 850.817 691.956 851.188 691.615C851.325 691.491 851.473 691.377 851.63 691.274L855.289 688.955",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M860.347 690.606C861.324 691.393 862.246 692.235 863.108 693.127L865.746 695.522L869.17 695.106L872.028 694.237L873.478 692.497",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.366 677.057C801.283 677.372 801.366 696.33 801.366 696.33",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.495 763.89L730.247 512.314",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.801 636.62L911.304 637.452",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.312 612.038V632.949C875.32 633.894 875.731 634.798 876.458 635.47V635.47C876.848 635.825 877.314 636.101 877.828 636.281C878.341 636.461 878.891 636.541 879.44 636.516L911.31 635.168",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.312 617.989H900.401C900.709 617.989 901.016 618.027 901.312 618.102L901.892 618.253C902.599 618.437 903.221 618.825 903.664 619.359C904.107 619.894 904.348 620.545 904.35 621.216V621.216C904.35 622.031 904.705 622.814 905.337 623.39C905.969 623.967 906.826 624.291 907.719 624.291H910.826",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.472 635.864V619.931L896.935 615.747V611.297",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M885.615 611.297V617.99",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.671 613.058V618.428H857.615",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.386 562.123V565.123C849.38 566.286 849.876 567.405 850.767 568.236C851.233 568.656 851.789 568.984 852.399 569.201C853.009 569.418 853.661 569.519 854.316 569.497L883.783 568.715",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M895.472 578.36L897.764 575.121C898.477 574.112 899.417 573.253 900.522 572.601C901.627 571.949 902.87 571.519 904.171 571.339L908.852 570.696",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M908.851 573.117L917.577 572.222L919.138 560.487",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.344 540.657C921.496 541.262 921.344 560.497 921.344 560.497",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.037 525.844H916.661",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.204 554.423L888.077 509.146",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.474 463.894C883.977 463.894 878.247 463.894 878.247 463.894L876.424 461.235V457.34",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814.068 434.333L847.277 433.413L851.461 429.594L861.817 428.711",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M813.797 427.414H834.62C835.431 427.412 836.229 427.223 836.939 426.864C837.649 426.505 838.248 425.987 838.679 425.359V425.359C839.153 424.663 839.407 423.86 839.411 423.04V418.616",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.416 414.873V407.033",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1259.14 860.022L1255.93 808.721",
    stroke: "#00A8E2",
    strokeOpacity: 0.25,
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.576 723.946L969.477 713.244L974.573 854.974V879.364C974.571 882.605 974.173 885.835 973.385 888.995L973.206 889.713C972.417 892.873 972.019 896.103 972.018 899.343V937.158C972.015 940.839 970.707 944.421 968.29 947.368C965.766 950.461 962.169 952.682 958.086 953.67L943.007 957.275L743.975 978.565L634.531 984.603L480.79 988.788L198.535 995.758L0 1003.2",
    stroke: "#FCD5B8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.59 1081.32L1402.93 853.413L1385.76 369.258L1382.99 284.855V220.356C1382.99 200.029 1388.38 178.851 1385.76 159.5C1382.99 139 1375 124 1376.5 109C1377.7 97.0005 1377 82.3338 1376.5 76.5005C1377.74 66.6672 1380.77 45.0005 1382.99 37.0005C1385.21 29.0005 1385.76 15.6672 1385.76 10.0005L1382.99 -15.9995",
    stroke: "#FCD5B8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1216.55 1052.33L1213 946.88V906.947L1219.03 889.452C1219.03 889.452 1227.58 874.805 1227.58 874.238C1227.58 873.67 1231.96 863.397 1231.96 863.397L1230.49 808.957L1226.35 704.588C1226.35 704.588 1224.7 641.261 1224.7 640.694C1224.7 640.126 1223.02 623.576 1222.5 623.047C1221.98 622.517 1213.03 603.459 1213.03 603.459C1213.03 603.459 1204.07 579.686 1204.07 579.106C1204.07 578.526 1202.19 557.425 1202.19 557.425L1200.1 494.287L1198.16 454.128L1194.01 436.821L1190.88 360.751L1188.26 287.176",
    stroke: "#FCD5B8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.22 713.234L1180.07 707.473L1322.1 702.898L1479.21 698.335L1569.33 694.427L1584.14 676.049L1590.72 669.949C1604.28 657.381 1620.87 647.884 1639.17 642.218V642.218C1644.17 640.657 1649.28 639.394 1654.47 638.436L1673.11 634.995C1678.61 633.981 1684.18 633.312 1689.78 632.991L1755.79 629.209C1765.51 628.647 1775.27 629.13 1784.86 630.646L1803.46 633.609C1810.78 634.767 1817.96 636.526 1824.93 638.865L1880.51 657.495C1885.83 659.266 1891 661.372 1896 663.797L1929.52 680.083",
    stroke: "#FCD5B8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.573 870.303L981.906 891.731V917.306C981.906 921.491 982.086 925.689 982.445 929.911C983.64 943.866 986.815 957.619 991.89 970.827L994.872 978.592L1010.92 1020.36L1018.8 1040.73L1024.45 1064.68L1022.41 1081.35L965.392 999.503L946.557 973.524L920.598 927.453L891.076 891.681L866.635 867.051L836.091 841.488L820.308 820.576L799.913 786.24C798.256 783.435 796.158 780.866 793.686 778.614V778.614C788.326 773.721 781.42 770.485 773.94 769.362L691.726 757.022C689.225 756.666 686.756 756.144 684.338 755.459L672.878 752.094C665.066 749.809 657.965 745.855 652.165 740.56L643.673 732.77L634.518 716.964",
    stroke: "#FCD5B8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.472 713.236L965.91 662.35C965.384 654.687 964.24 647.07 962.485 639.56L945.998 568.973C945.446 566.569 944.731 564.199 943.858 561.876L935.905 540.649L916.753 494.919C915.276 491.374 913.517 487.932 911.492 484.621L887.769 445.697L851.481 394.168L819.805 345.802L798.402 310.71L776.585 277.547L757.668 253.219C753.459 247.765 748.797 242.616 743.721 237.816L729.292 224.215C723.195 219.977 710.103 209.9 706.503 203.5C702.003 195.5 706.503 190.5 691.503 171.5C676.503 152.5 656.003 104 653.003 100C650.003 96.0005 647.003 92.5005 642.003 81.5005C637.003 70.5005 618.503 25.5005 615.003 24.0005C612.203 22.8005 597.503 9.50049 590.503 3.00049L566.003 -4.99951",
    stroke: "#FCD5B8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2135_45677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.97717fde100b501fa077f7ca6dfba839.svg";
export { ForwardRef as ReactComponent };